import { useState } from "react";
import { Form, Button, Row, Col } from "reactstrap";
import LoginError from "./loginError";
import { RadioSelectionWithLabel, ButtonWithLoading } from "../../../components/common/standardComponents";
interface MfaMethodFormProps {
	isLoading: boolean;
	error: string;
	onSubmit: (method: string) => void;
	onCancel: () => void;
}

const methodList = [
	{
		label: 'SMS',
		value: 'SMS',
	},
	{
		label: 'Email',
		value: 'Email',
	},
	// {
	// 	label: 'Authenticator',
	// 	value: 'Authenticator',
	// },
];

export interface mfaMethodValues {
	mfaMethod: string;
}

const initialValues: mfaMethodValues = {
	mfaMethod: '',
};

export function MfaMethodForm(props: MfaMethodFormProps) {
	const { isLoading, error, onSubmit, onCancel } = props;

	const [selectedMfaMethod, setSelectedMfaMethod] = useState<string>(initialValues.mfaMethod);
	const [isCodeSending, setIsCodeSending] = useState<boolean>(false);

	const handleSubmit = (e: any) => {
		e.preventDefault();
		setIsCodeSending(true);
		onSubmit(selectedMfaMethod);
	};

	const handleCancel = () => {
		onCancel();
	};

	const isValid = () => {
		return selectedMfaMethod;
	}

	return (
		<div className="fadeIn">
			<div className="text-left">
				<h2>Verify your identity</h2>
				<Form onSubmit={handleSubmit}>
					{error && <LoginError isLoading={isLoading} error={error} />}
					<RadioSelectionWithLabel
						options={methodList}
						id='mfaMethod'
						label='Choose method:'
						isRequired={true}
						value={selectedMfaMethod}
						onChange={(e: any) => setSelectedMfaMethod(e.target.value)}
					/>
					<br/>
					<Row>
						<Col>
							<ButtonWithLoading
								isLoading={isCodeSending}
								disabled={props.isLoading && !selectedMfaMethod && isCodeSending}
								type="submit"
								text={"Send Code"}
								loadingText="Sending..."
								style={{ marginRight: '10px' }}
								isValid={() => isValid()}
							/>
							<Button type="button" onClick={handleCancel}>Cancel</Button>
						</Col>
					</Row>
				</Form>
			</div>
		</div>
	);
}

export default MfaMethodForm;
